// 分类筛选条件（前端演示用）

export const genreOptions = [
  '全部',
  '剧情',
  '爱情',
  '犯罪',
  '悬疑',
  '科幻',
  '动作',
  '古装',
  '武侠',
  '喜剧',
  '真人秀',
  '音乐',
  '美食',
  '旅行',
  '纪录片',
];

export const regionOptions = ['全部', '国产', '欧美', '日韩'];

export const yearOptions = ['全部', '2024', '2023', '2022', '2021'];

export const sortOptions = [
  { key: 'updated', label: '更新时间' },
  { key: 'rating', label: '评分' },
  { key: 'popularity', label: '热度' },
];